/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LocationAddressComponentType {
  administrative_area_level_1 = "administrative_area_level_1",
  administrative_area_level_2 = "administrative_area_level_2",
  administrative_area_level_3 = "administrative_area_level_3",
  administrative_area_level_4 = "administrative_area_level_4",
  administrative_area_level_5 = "administrative_area_level_5",
  airport = "airport",
  archipelago = "archipelago",
  art_gallery = "art_gallery",
  bar = "bar",
  bus_station = "bus_station",
  cafe = "cafe",
  car_rental = "car_rental",
  car_repair = "car_repair",
  clothing_store = "clothing_store",
  colloquial_area = "colloquial_area",
  continent = "continent",
  country = "country",
  electronic_store = "electronic_store",
  establishment = "establishment",
  finance = "finance",
  floor = "floor",
  food = "food",
  general_contractor = "general_contractor",
  health = "health",
  home_goods_store = "home_goods_store",
  insurance_agency = "insurance_agency",
  intersection = "intersection",
  lawyer = "lawyer",
  light_rail_station = "light_rail_station",
  local_government_office = "local_government_office",
  locality = "locality",
  lodging = "lodging",
  metal_takeaway = "metal_takeaway",
  moving_company = "moving_company",
  natural_feature = "natural_feature",
  neighborhood = "neighborhood",
  painter = "painter",
  park = "park",
  parking = "parking",
  plus_code = "plus_code",
  point_of_interest = "point_of_interest",
  political = "political",
  post_box = "post_box",
  postal_code = "postal_code",
  postal_code_prefix = "postal_code_prefix",
  postal_code_suffix = "postal_code_suffix",
  postal_town = "postal_town",
  premise = "premise",
  real_estate_agency = "real_estate_agency",
  restaurant = "restaurant",
  room = "room",
  route = "route",
  school = "school",
  shopping_mall = "shopping_mall",
  storage = "storage",
  store = "store",
  street_address = "street_address",
  street_number = "street_number",
  sublocality = "sublocality",
  sublocality_level_1 = "sublocality_level_1",
  sublocality_level_2 = "sublocality_level_2",
  sublocality_level_3 = "sublocality_level_3",
  sublocality_level_4 = "sublocality_level_4",
  sublocality_level_5 = "sublocality_level_5",
  subpremise = "subpremise",
  subway_station = "subway_station",
  train_station = "train_station",
  transit_station = "transit_station",
  travel_agency = "travel_agency",
  unknown = "unknown",
  ward = "ward",
}

export const LocationAddressComponentTypeDisplay: Record<LocationAddressComponentType, string> = {
  [LocationAddressComponentType.administrative_area_level_1]: "Administrative Area Level 1",
  [LocationAddressComponentType.administrative_area_level_2]: "Administrative Area Level 2",
  [LocationAddressComponentType.administrative_area_level_3]: "Administrative Area Level 3",
  [LocationAddressComponentType.administrative_area_level_4]: "Administrative Area Level 4",
  [LocationAddressComponentType.administrative_area_level_5]: "Administrative Area Level 5",
  [LocationAddressComponentType.airport]: "Airport",
  [LocationAddressComponentType.archipelago]: "Archipelago",
  [LocationAddressComponentType.art_gallery]: "Art Gallery",
  [LocationAddressComponentType.bar]: "Bar",
  [LocationAddressComponentType.bus_station]: "Bus Station",
  [LocationAddressComponentType.cafe]: "Cafe",
  [LocationAddressComponentType.car_rental]: "Car Rental",
  [LocationAddressComponentType.car_repair]: "Car Repair",
  [LocationAddressComponentType.clothing_store]: "Clothing Store",
  [LocationAddressComponentType.colloquial_area]: "Colloquial Area",
  [LocationAddressComponentType.continent]: "Continent",
  [LocationAddressComponentType.country]: "Country",
  [LocationAddressComponentType.electronic_store]: "Electronic Store",
  [LocationAddressComponentType.establishment]: "Establishment",
  [LocationAddressComponentType.finance]: "Finance",
  [LocationAddressComponentType.floor]: "Floor",
  [LocationAddressComponentType.food]: "Food",
  [LocationAddressComponentType.general_contractor]: "General Contractor",
  [LocationAddressComponentType.health]: "Health",
  [LocationAddressComponentType.home_goods_store]: "Home Goods Store",
  [LocationAddressComponentType.insurance_agency]: "Insurance Agency",
  [LocationAddressComponentType.intersection]: "Intersection",
  [LocationAddressComponentType.lawyer]: "Lawyer",
  [LocationAddressComponentType.light_rail_station]: "Light Rail Station",
  [LocationAddressComponentType.local_government_office]: "Local Government Office",
  [LocationAddressComponentType.locality]: "Locality",
  [LocationAddressComponentType.lodging]: "Lodging",
  [LocationAddressComponentType.metal_takeaway]: "Metal Takeaway",
  [LocationAddressComponentType.moving_company]: "Moving Company",
  [LocationAddressComponentType.natural_feature]: "Natural Feature",
  [LocationAddressComponentType.neighborhood]: "Neighborhood",
  [LocationAddressComponentType.painter]: "Painter",
  [LocationAddressComponentType.park]: "Park",
  [LocationAddressComponentType.parking]: "Parking",
  [LocationAddressComponentType.plus_code]: "Plus Code",
  [LocationAddressComponentType.point_of_interest]: "Point Of Interest",
  [LocationAddressComponentType.political]: "Political",
  [LocationAddressComponentType.post_box]: "Post Box",
  [LocationAddressComponentType.postal_code]: "Postal Code",
  [LocationAddressComponentType.postal_code_prefix]: "Postal Code Prefix",
  [LocationAddressComponentType.postal_code_suffix]: "Postal Code Suffix",
  [LocationAddressComponentType.postal_town]: "Postal Town",
  [LocationAddressComponentType.premise]: "Premise",
  [LocationAddressComponentType.real_estate_agency]: "Real Estate Agency",
  [LocationAddressComponentType.restaurant]: "Restaurant",
  [LocationAddressComponentType.room]: "Room",
  [LocationAddressComponentType.route]: "Route",
  [LocationAddressComponentType.school]: "School",
  [LocationAddressComponentType.shopping_mall]: "Shopping Mall",
  [LocationAddressComponentType.storage]: "Storage",
  [LocationAddressComponentType.store]: "Store",
  [LocationAddressComponentType.street_address]: "Street Address",
  [LocationAddressComponentType.street_number]: "Street Number",
  [LocationAddressComponentType.sublocality]: "Sublocality",
  [LocationAddressComponentType.sublocality_level_1]: "Sublocality Level 1",
  [LocationAddressComponentType.sublocality_level_2]: "Sublocality Level 2",
  [LocationAddressComponentType.sublocality_level_3]: "Sublocality Level 3",
  [LocationAddressComponentType.sublocality_level_4]: "Sublocality Level 4",
  [LocationAddressComponentType.sublocality_level_5]: "Sublocality Level 5",
  [LocationAddressComponentType.subpremise]: "Subpremise",
  [LocationAddressComponentType.subway_station]: "Subway Station",
  [LocationAddressComponentType.train_station]: "Train Station",
  [LocationAddressComponentType.transit_station]: "Transit Station",
  [LocationAddressComponentType.travel_agency]: "Travel Agency",
  [LocationAddressComponentType.unknown]: "Unknown",
  [LocationAddressComponentType.ward]: "Ward",
};
